import styled from "styled-components";
import { useEffect, useState } from "react";
import Button from "@material-ui/core/Button";
import { CircularProgress } from "@material-ui/core";
import { GatewayStatus, useGateway } from "@civic/solana-gateway-react";
import { CandyMachine } from "./candy-machine";
import { db } from "./resources/firebaseConfig";
import {
  collection,
  getDocs,
  addDoc,
  updateDoc,
  doc,
  getDoc,
  setDoc,
} from "firebase/firestore";

export const CTAButton = styled(Button)`
  display: block !important;
  margin: 0 auto !important;
  background-color: var(--title-text-color) !important;
  min-width: 120px !important;
  font-size: 1em !important;
`;

export const MintButton = ({
  onMint,
  candyMachine,
  isMinting,
  isEnded,
  isActive,
  isSoldOut,
  wallet,
}: {
  onMint: () => Promise<void>;
  candyMachine: CandyMachine | undefined;
  isMinting: boolean;
  isEnded: boolean;
  isActive: boolean;
  isSoldOut: boolean;
  wallet: string;
}) => {
  const { requestGatewayToken, gatewayStatus } = useGateway();
  const [clicked, setClicked] = useState(false);
  const [isVerifying, setIsVerifying] = useState(false);
  const [isPass, setIsPass] = useState(false);
  const [isDBExist, setIsDBExist] = useState(false);

  const getEqualPass = async () => {
    const colRef = doc(db, process.env.REACT_APP_FIREBASE_COLLECTION, wallet);
    const record = await getDoc(colRef);
    if (record.exists()) {
      let ttlMintStock = record.data()["totalMintStock"] || null
      if (ttlMintStock !== undefined) {
        if (record.data()["totalMintStock"] === 0) {
          setIsPass(true);
        }
      }
    }
  };

  useEffect(() => {
    setIsVerifying(false);
    if (
      gatewayStatus === GatewayStatus.COLLECTING_USER_INFORMATION &&
      clicked
    ) {
      // when user approves wallet verification txn
      setIsVerifying(true);
    } else if (gatewayStatus === GatewayStatus.ACTIVE && clicked) {
      console.log("Verified human, now minting...");
      onMint();
      setClicked(false);
    }

    getEqualPass();
  }, [gatewayStatus, clicked, setClicked, onMint]);

  return (
    <CTAButton
      disabled={
        clicked ||
        candyMachine?.state.isSoldOut ||
        isSoldOut ||
        isMinting ||
        isEnded ||
        !isActive ||
        isVerifying ||
        isPass
      }
      onClick={async () => {
        if (
          isActive &&
          candyMachine?.state.gatekeeper &&
          gatewayStatus !== GatewayStatus.ACTIVE
        ) {
          console.log("Requesting gateway token");
          setClicked(true);
          await requestGatewayToken();
        } else {
          console.log("Minting...");
          await onMint();
        }
      }}
      variant="contained"
    >
      {!candyMachine ? (
        "CONNECTING..."
      ) : isPass ? (
        "YOUR MINT IS OUT OF STOCK"
      ) : candyMachine?.state.isSoldOut || isSoldOut ? (
        "SOLD OUT"
      ) : isActive ? (
        isVerifying ? (
          "VERIFYING..."
        ) : isMinting || clicked ? (
          <CircularProgress />
        ) : (
          "MINT"
        )
      ) : isEnded ? (
        "ENDED"
      ) : candyMachine?.state.goLiveDate ? (
        "SOON"
      ) : (
        "UNAVAILABLE"
      )}
    </CTAButton>
  );
};
